import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Alert, AlertConfiguration } from '../../alert';
import { AlertManagementService } from '../../alert-management.service';
import { DataManagementService } from '../../../data-management/data-management.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-non-poi-settings',
  templateUrl: './non-poi-settings.component.html',
  styleUrls: ['./non-poi-settings.component.css']
})
export class NonPoiSettingsComponent implements OnInit, OnDestroy {
  public checked = true;
  public showAdvancedSettings = false;

  public stopTimeSelectMode = true;
  minutes: string[] = []
  public stopTime: number | null;

  public alert: Alert = new Alert();

  public nonPoiAlertConfiguration: AlertConfiguration = new AlertConfiguration();
  public cronAlertConfiguration: AlertConfiguration = new AlertConfiguration();
  public loader = false;

  public enableGlobalConfig = false;
  public enableGlobalConfigToAllVehicules = false;


  getVehiculeWasSelectedSubscription: Subscription;

  constructor(
    private toastr: ToastrService,
    private alertManagementService: AlertManagementService,
    private dataManagementService: DataManagementService
  ) {
    this.initMinutes();
  }

  ngOnInit() {
    if (this.dataManagementService.selectedVehicule) {
      this.loadAlertConfigOfDevice(
        this.dataManagementService.selectedVehicule.idDevice
      );
    }

    this.getVehiculeWasSelectedSubscription = this.dataManagementService
      .getVehiculeWasSelected()
      .subscribe(vehicule => {
        const idDevice = this.dataManagementService.selectedVehicule?.idDevice;
        if (idDevice) {
          this.loadAlertConfigOfDevice(idDevice);
        } else {
          console.warn('Selected vehicule is null or does not have an idDevice');
          // Gérez le cas où idDevice est undefined
        }
      });

  }

  ngOnDestroy() {
    if (this.getVehiculeWasSelectedSubscription) {
      this.getVehiculeWasSelectedSubscription.unsubscribe();
    }
  }

  loadAlertConfigOfDevice(device: number) {
    this.loader = true;
    this.alertManagementService
      .getAlertByNameAndDeviceId('STOP_NO_POI', device)
      .subscribe(
        alert => {
          this.alert = alert;
          this.cronAlertConfiguration = this.alert.alertConfigurations.filter(
            alertConfiguration => alertConfiguration.type === 'DATE'
          )
            ? this.alert.alertConfigurations.filter(
                alertConfiguration => alertConfiguration.type === 'DATE'
              )[0]
            : this.cronAlertConfiguration;
          this.nonPoiAlertConfiguration = this.alert.alertConfigurations.filter(
            alertConfiguration => alertConfiguration.type === 'STOP_NO_POI'
          )
            ? this.alert.alertConfigurations.filter(
                alertConfiguration => alertConfiguration.type === 'STOP_NO_POI'
              )[0]
            : this.nonPoiAlertConfiguration;

          this.loader = false;
          this.toastr.success('Configuration chargée', 'info !', {
            timeOut: 1000
          });
        },
        () => {
          this.loader = false;
          this.toastr.error('Configuration non chargée', 'info !', {
            timeOut: 1000
          });
        }
      );
  }

  collapseAdvancedSettings() {
    this.showAdvancedSettings = !this.showAdvancedSettings;
  }

  chooseStopTime($event: any) {
    if ($event === 'Autre..') {
      this.stopTimeSelectMode = false;
      this.nonPoiAlertConfiguration.value2 = '10';
    }
  }

  initMinutes() {
    for (var i = 1; i <= 12; i++) {
      this.minutes.push((i * 10).toString());
    }
    this.minutes.push('Autre..');
  }

  save() {
    this.loader = true;
    this.alert.enableGlobalConfig = this.enableGlobalConfig;
    this.alertManagementService.updateAlert(this.alert).subscribe(
      alert => {
        this.alert = alert;
        this.toastr.success('Configuration enregistrer', 'info !');
        this.loader = false;
      },
      error => {
        this.loader = false;
        this.toastr.error('Configuration non enregistrée', 'info !');
      }
    );
  }

  emailSettings(emailsSettings: { emailMode: boolean; emails: string, enableGlobalConfig: boolean, enableGlobalConfigToAllVehicules: boolean  }) {
    this.alert.emailMode = emailsSettings.emailMode;
    this.alert.emails = emailsSettings.emails;
    this.enableGlobalConfig = emailsSettings.enableGlobalConfig;
    this.enableGlobalConfigToAllVehicules = emailsSettings.enableGlobalConfigToAllVehicules;
    if (emailsSettings.enableGlobalConfig || emailsSettings.enableGlobalConfigToAllVehicules) {
      this.updateEmails();
    }
  }

  updateEmails() {
    let id = 0;
    if (this.enableGlobalConfig || this.enableGlobalConfigToAllVehicules) {
      id = this.alert.deviceId;
    } else {
      id = this.alert.id;
    }
    this.alertManagementService.setEmailToAllAlert(this.alert.emails, id, this.enableGlobalConfig, this.enableGlobalConfigToAllVehicules)
      .subscribe(res => {
        if (res) {
          this.toastr.success('emails bien copiés ');
        } else {
          this.toastr.warning('Veuillez reverifier');
        }
      }
      )
  }
}
